import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { createNotification } from "../../../shared/store/notifications";

export const completeAddressInfo = async (zipCode) => {
  const res = await axios.get(`https://viacep.com.br/ws/${zipCode}/json/`);
  if (res.data.erro === "true") {
    throw new Error();
  }
  return res.data;
};

export const useCompleteAdressInfo = ({ config } = {}) => {
  return useMutation({
    ...config,
    mutationFn: completeAddressInfo,
    onError: () => {
      createNotification({
        type: "error",
        message: "Ops, aconteceu algum erro.",
      });
    },
  });
};
